module.exports = __webpack_public_path__ + "img/14.8734eba5.gif";